import { render, staticRenderFns } from "./SetDepartmentDialog.vue?vue&type=template&id=6b10c223&scoped=true"
import script from "./SetDepartmentDialog.vue?vue&type=script&lang=js"
export * from "./SetDepartmentDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b10c223",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b10c223')) {
      api.createRecord('6b10c223', component.options)
    } else {
      api.reload('6b10c223', component.options)
    }
    module.hot.accept("./SetDepartmentDialog.vue?vue&type=template&id=6b10c223&scoped=true", function () {
      api.rerender('6b10c223', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sportCenter/components/SetDepartmentDialog.vue"
export default component.exports